
const oneDay = 86400000;

const blankGenerate = {
  originalFilename: '',
  type: 'sbt',
  chapter: '',
  paragraph: '',
  additional: '',
  change: false,
  preview: '',
  title: '',
  includeFromDate: new Date(new Date().getTime() -  oneDay * 5).toISOString().slice(0, 10)
};

export default (state = {
  loading: true,
  loadingEmails: false,
  sendingEmail: false,
  list: [],
  allDatabases: [],
  newsletters: [],
  newsletterId: -1,
  newsletter: null,
  generate: Object.assign({}, blankGenerate),
  showNew: false,
  notSentCount: 0,
  sentCount: 0,
  failedCount: 0,
  showEmailDialog: false,
  showSendDialog: false,
  emails: [],
  published: false
}, action) => {

  switch (action.type) {
    case 'FETCH_NEWSLETTER_WEEKS_BEGIN':
      return { ...state, loading: true, newsletter: null };
    case 'FETCH_NEWSLETTERS_BEGIN':
      return { ...state, loading: true };
    case 'FETCH_NEWSLETTER_WEEKS_SUCCESS':
      return {
        ...state,
        list: action.payload.categories.entries,
        allDatabases: action.payload.allDatabases,
        currentYear: action.payload.currentYear,
        currentWeek: action.payload.currentWeek,
        loading: false,
        week: action.payload.categories.entries[0].id
      };
    case 'FETCH_NEWSLETTERS_SUCCESS':
      let preselected = action.payload.find(n => n.database === state.database);

      if (!preselected) {
        preselected = action.payload[0];
      }

      return { ...state, loading: false, published: preselected.published, newsletters: action.payload, database: preselected.database, newsletterId: preselected.newsletterId, week: action.week };
    case 'CHANGE_NEWSLETTER_WEEK':
      return { ...state, week: action.payload };
    case 'CHANGE_NEWSLETTER':
      return { ...state, newsletterId: action.payload.newsletterId, database: action.payload.database, published: action.payload.published };
    case 'NEWSLETTER_EDIT_BEGIN':
      return { ...state, loading: true, newsletter: null };
    case 'NEWSLETTER_EDIT_SUCCESS':
      return { ...state, loading: false, newsletter: action.payload, generate: Object.assign({id: action.payload.id}, blankGenerate) };
    case 'NEWSLETTER_EDIT_ATTR':
      let newsletter = state.newsletter;
      newsletter[action.payload.attr] = action.payload.value;
      return { ...state, newsletter };
    case 'NEWSLETTER_EDIT_GENERATE_ATTR':
      let generate = Object.assign({}, state.generate)
      generate[action.payload.attr] = action.payload.value;

      if (action.payload.attr === 'type') {
        generate.originalFilename = '';
      }

      return { ...state, generate };
    case 'FETCH_NEWSLETTER_GENERATE_BEGIN':
      return { ...state, loading: true };
    case 'FETCH_NEWSLETTER_GENERATE_SUCCESS':
      let g = state.generate;
      g['preview'] = action.payload.message;
      return { ...state, generate: g, loading: false };
    case 'NEWSLETTER_SAVE_BEGIN':
      return { ...state, loading: true };
    case 'NEWSLETTER_SAVE_SUCCESS':
      return { ...state, loading: false, newsletter: action.payload, published: action.payload.published };
    case 'NEWSLETTER_DELETE_BEGIN':
      return { ...state, loading: true };
    case 'NEWSLETTER_DELETE_SUCCESS':
      document.location.href = '/nyhetsbrev';
      return { ...state };
    case 'NEWSLETTER_CREATE':
      return { ...state, showNew: true };
    case 'NEWSLETTER_CREATE_HIDE':
      return { ...state, showNew: false };
    case 'NEWSLETTER_CREATE_SUBMIT_BEGIN':
      return { ...state, loading: true, showNew: false };
    case 'NEWSLETTER_CREATE_SUBMIT_SUCCESS':      
      alert(action.payload + ' nyhetsbrev skapade');
      document.location.reload();
      return { ...state };
    case 'NEWSLETTER_FETCH_STATS_SUCCESS':
      return { ...state, ...action.payload };
    case 'NEWSLETTER_TOGGLE_EMAIL_DIALOG':
      return { ...state, showEmailDialog: action.payload };
    case 'NEWSLETTER_TOGGLE_SEND_DIALOG':
      return { ...state, showSendDialog: action.payload };
    case 'NEWSLETTER_FETCH_EMAILS_BEGIN':
      return { ...state, showEmailDialog: true, emails: [], loadingEmails: true };
    case 'NEWSLETTER_FETCH_EMAILS_SUCCESS':

      let sentCount = action.payload.filter(e => e.sentCount > 0).length;
      let failedCount = action.payload.filter(e => e.sentCount === -1).length;
      let notSentCount = action.payload.length - sentCount;

      return { ...state, showEmailDialog: true, notSentCount, sentCount, failedCount, emails: action.payload, loadingEmails: false };
    case 'NEWSLETTER_SEND_BEGIN':
      return { ...state, sendingEmail: true };
    case 'NEWSLETTER_SEND_SUCCESS':
      return { ...state, showSendDialog: false, sendingEmail: false };
    case 'GENERATE_NEWSLETTER_BEGIN':
      return { ...state, loading:true }
    case 'GENERATE_NEWSLETTER_SUCCESS':
      document.getElementById('newsletter_preview').src = document.getElementById('newsletter_preview').src;
      return { ...state, loading:false }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/newsletter/newsletterReducers.js